import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import voca from 'voca';
import cx from 'classnames';
import { TextInput } from '../../../common/text-input';
import t from 'common/i18n';
import bindActions, { types as ats } from '../../actions';
import { selectAdvancedOptions } from '../../selectors';
import TaggedInput from '../TaggedInput';
import UploadPresetInput from '../UploadPresetInput';
import { getComponentConsumer } from '../UploadContainer/uploaderContext';
import FingerprintIcon from '~/assets/images/ico-id2.svg';
import { debounce } from 'lodash';

import './AdvancedOptions.scss';
import { createAnalyticsAdvancedEventName, sendAnalytics } from '../../../common/analytics/analytics.helpers';
import { AnalyticsLevels } from '../../../common/analytics/analytics.constants';

export class AdvancedOptions extends Component {
  state = {
    suggestionsOpen: false,
  };

  componentDidMount() {
    const { uploader, useUploadPresetsCallback, useTagsCallback } = this.props;
    if (useUploadPresetsCallback) {
      uploader.retrieveClientUploadPresets();
    }
    if (useTagsCallback) {
      uploader.retrieveClientTags();
    }
  }

  componentDidUpdate() {
    if (this.props.publicIdError && this.idInputRef.current) {
      this.idInputRef.current.focus();
    }
  }

  onPublicIdChange = (e) => {
    if (e.target) {
      sendAnalytics([AnalyticsLevels.advanced, AnalyticsLevels.public_id], createAnalyticsAdvancedEventName(AnalyticsLevels.public_id));
      this.props[ats.SET_PUBLIC_ID]({ value: voca.trimLeft(e.target.value) });
    }
  };

  onTagsChange = (tags = []) => {
    sendAnalytics([AnalyticsLevels.advanced, AnalyticsLevels.tags], createAnalyticsAdvancedEventName(AnalyticsLevels.tags));
    //set new tags
    this.props[ats.SET_UPLOAD_TAGS]({ tags });
  };

  onUploadPresetChange = (uploadPreset) => {
    sendAnalytics([AnalyticsLevels.advanced, AnalyticsLevels.uw_presets], createAnalyticsAdvancedEventName(AnalyticsLevels.uw_presets));
    this.props[ats.SET_UPLOAD_PRESET]({ uploadPreset });
  };

  onKeyUp = (e) => {
    if (e.which === 27 || e.key === 'Escape') {
      e.stopPropagation(); // dont propagate the esc so the widget stays open
    }
  };

  tagsInputChangeHandler = (value) => {
    const { uploader, useTagsCallback } = this.props;
    if (useTagsCallback) {
      debounce(() => uploader.retrieveClientTags(value), 200)();
    }
    this.props[ats.SET_TAGS_INPUT_VALUE]({ value });
  };

  idInputRef = createRef();

  render() {
    const { props } = this;
    const errorableBorder = {
      'bc-window-border': !props.publicIdError,
      'bc-error': props.publicIdError,
    };

    //first item in suggestedUploadPresets is always ''
    const isUploadPresetInputDisplay = props.useUploadPresetsCallback && props.suggestedUploadPresets?.length > 1;

    return (
      <div className={cx('slide bt', errorableBorder)} onKeyUp={this.onKeyUp}>
        <div className="field id">
          <TextInput
            type="text"
            data-test="public-id"
            ref={this.idInputRef}
            placeholder={t('advanced_options.public_id_ph')}
            className={cx(errorableBorder)}
            value={props.setPublicId || ''}
            startAdornment={<img src={FingerprintIcon} />}
            onChange={throttle(this.onPublicIdChange, 100)}
            id={'adv-public-id'}
          />
        </div>
        <div className={cx('field tag', { 'tags-suggestions-open': this.state.suggestionsOpen })}>
          <TaggedInput
            id="adv-tag-select"
            values={props.setTags}
            suggestions={props.suggestedTags}
            changeHandler={this.onTagsChange}
            inputChangeHandler={this.tagsInputChangeHandler}
            inputValue={props.tagsInputValue}
          />
        </div>
        {isUploadPresetInputDisplay && (
          <div className={cx('field upload-preset')}>
            <UploadPresetInput options={props.suggestedUploadPresets} onChange={this.onUploadPresetChange} value={props.setUploadPreset} />
          </div>
        )}
      </div>
    );
  }
}

export default connect(selectAdvancedOptions, bindActions)(getComponentConsumer(AdvancedOptions));
